import { PayoutType } from '../enums/payoutType';

export function getActivityNameFromPayoutType(payoutType: PayoutType) {
    switch (payoutType) {
        case PayoutType.specialist:
            return 'Consult';
        case PayoutType.biometrician:
            return 'Biometrie';
        case PayoutType.grader:
            return 'Grading';
        case PayoutType.supervisor:
            return 'Kwaliteitscontrole';
        case PayoutType.requester:
            return 'Aanvraag';
        default:
            return undefined;
    }
}
